import React, { useState } from "react";
import { dateFine } from "../../../util/Utilities";
import DateFormatter from "../../DateFormatter";
import { Image, Modal, Button } from "react-bootstrap";
import profileImg from "../../../assets/images/profile.png";
import { AiFillStar } from "react-icons/ai";

const SCORE_COLORS = {
    1: { bg: "#fee2e2", text: "#dc2626", label: "Muy insatisfecho" },
    2: { bg: "#ffedd5", text: "#ea580c", label: "Insatisfecho" },
    3: { bg: "#fef9c3", text: "#ca8a04", label: "Regular" },
    4: { bg: "#dbeafe", text: "#2563eb", label: "Satisfecho" },
    5: { bg: "#dcfce7", text: "#16a34a", label: "Muy satisfecho" },
};

const CommentCell = ({ comment }) => {
    const [showFull, setShowFull] = useState(false);

    if (!comment) return <span className="text-muted">--</span>;

    const isLong = comment.length > 80;

    return (
        <div>
            <span style={{ fontSize: "0.82rem", color: "#334155" }}>
                {isLong ? `${comment.substring(0, 80)}...` : comment}
            </span>
            {isLong && (
                <>
                    <button
                        className="btn btn-link p-0 ms-1"
                        style={{ fontSize: "0.75rem", textDecoration: "underline", verticalAlign: "baseline" }}
                        onClick={() => setShowFull(true)}
                    >
                        Ver más
                    </button>
                    <Modal show={showFull} onHide={() => setShowFull(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title style={{ fontSize: "1rem", fontWeight: 700 }}>
                                Comentario de la encuesta
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ whiteSpace: "pre-wrap", fontSize: "0.9rem" }}>
                            {comment}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" size="sm" onClick={() => setShowFull(false)}>
                                Cerrar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            )}
        </div>
    );
};

const SatisfactionSurveysColumns = [
    {
        Label: () => 'ID',
        accessor: 'id'
    },
    {
        Label: () => 'Usuario',
        Component: ({ value }) => (
            <div className="d-flex align-items-center">
                <Image
                    style={{ height: 34, width: 34, marginRight: 10, flexShrink: 0, objectFit: 'cover' }}
                    src={value?.user?.imagePath || profileImg}
                    roundedCircle
                />
                <div>
                    <div className="fw-semibold" style={{ fontSize: '0.84rem' }}>
                        {value?.user?.name || '--'}
                    </div>
                    <small className="text-muted" style={{ fontSize: '0.74rem' }}>
                        {value?.user?.email || ''}
                    </small>
                </div>
            </div>
        )
    },
    {
        Label: () => 'Centro de Costo',
        Component: ({ value }) => (
            <div>
                <span className="fw-semibold" style={{ fontSize: '0.84rem' }}>
                    {value?.plan?.costCenter?.name || '--'}
                </span>
                {value?.plan?.costCenter?.code && (
                    <small className="text-muted d-block" style={{ fontSize: '0.74rem' }}>
                        Cód: {value?.plan?.costCenter?.code}
                    </small>
                )}
            </div>
        )
    },
    {
        Label: () => 'Planificación',
        Component: ({ value }) => (
            <div>
                <span style={{ fontSize: '0.82rem' }}>
                    {value?.plan?.planningProcess?.name || '--'}
                </span>
                {value?.plan?.planningProcess?.forYear && (
                    <span className="badge bg-light text-dark ms-1" style={{ fontSize: '0.72rem' }}>
                        {value?.plan?.planningProcess?.forYear}
                    </span>
                )}
            </div>
        )
    },
    {
        Label: () => 'Puntuación',
        Component: ({ value }) => {
            const score = Number(value?.score) || 0;
            const meta = SCORE_COLORS[score] || { bg: '#f1f5f9', text: '#64748b', label: 'Sin calificar' };

            return (
                <div>
                    <div className="d-flex align-items-center gap-1 mb-1">
                        {[1, 2, 3, 4, 5].map((star) => (
                            <AiFillStar
                                key={star}
                                size={15}
                                color={star <= score ? "#f59e0b" : "#e2e8f0"}
                            />
                        ))}
                    </div>
                    <span
                        className="badge"
                        style={{
                            backgroundColor: meta.bg,
                            color: meta.text,
                            fontSize: '0.72rem',
                            fontWeight: 600,
                            padding: '0.2rem 0.45rem'
                        }}
                    >
                        {score} / 5 — {meta.label}
                    </span>
                </div>
            );
        }
    },
    {
        Label: () => 'Comentario',
        Component: ({ value }) => <CommentCell comment={value?.comment} />
    },
    {
        Label: () => 'Fecha de Cierre',
        Component: ({ value }) => (
            <DateFormatter
                value={dateFine(value?.createdAt)}
                dateFormat="dd/MM/yyyy hh:mm:ss"
            />
        )
    }
];

export default SatisfactionSurveysColumns;
